<template>
  <div class="app">
    <!-- 使用Header组件 -->
    <HeaderView></HeaderView>
    <div class="body">
      <router-view/>
    </div>
    <FooterView></FooterView>
  </div>
</template>

<script>
import HeaderView from "./components/HeaderView";
import FooterView from "./components/FooterView";

export default {
  components: {
    HeaderView,
    FooterView
  },
  beforeCreate(){
    this.$store.dispatch('setInitLogin')
    this.$store.dispatch('getUser')
    this.$store.dispatch('getConfig')
  }
};
</script>

<style>
:root {
  --el-color-primary: #3C9C8F !important;
}
.el-button--primary {
  background-color: #3C9C8F !important;
  border-color: #3C9C8F !important;
}
.el-button--plain:hover {
  color: #3C9C8F !important;
  background-color: #3c9c8f1a !important;
  border-color: #3C9C8F !important;
}


html,body{
   height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
   background: #F5F5F8;
    /* font-family: Regular; */
    font-family: Source Han Sans, Source Han Sans;
}
.app{
  display: flex;
  flex-direction: column;
  background: #F5F5F8;
  height: 100%;
  width: 100%;
}
.body{
  flex: 1;
}
</style>
